// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import { installChunkReloadHandler } from './utils/chunk-reload.js';
import './styles/global.css';
import './styles/intake.css';
import './styles/admin.css';
import './styles/toast.css';
import './styles/components.css';
import './styles/design-system.css';
import './styles/high-contrast.css';

// Recover automatically from stale lazy-chunk loads after a deploy (a new build
// changes hashed asset names; an already-open tab still references the old ones).
installChunkReloadHandler();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
